export default "__VITE_ASSET__BY6qFvQ2__"